module.exports = __webpack_public_path__ + "img/cost@3x.f5329bbb.png";